import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

function mediaIds(gallery) {
  const scroller = gallery.querySelector('slideshow-component slideshow-slides');
  if (!scroller) return null;
  const slides = Array.from(scroller.children).filter(slide => slide.matches('slideshow-slide'));
  const ids = slides.map(slide => slide.querySelector('[data-media-id]')?.dataset.mediaId);
  return ids.length && ids.every(Boolean) ? ids : null;
}

export class MediaGallery extends Component {
  #controller = new AbortController();

  connectedCallback() {
    super.connectedCallback();
    const { signal } = this.#controller;
    this.closest('.shopify-section, dialog')?.addEventListener(
      ThemeEvents.variantUpdate, this.#handleVariantUpdate, { signal }
    );
    this.refs.zoomDialogComponent?.addEventListener(
      ThemeEvents.zoomMediaSelected, this.#handleZoomMediaSelected, { signal }
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }

  #handleVariantUpdate = (event) => {
    const data = event.detail.data;
    const source = data.html;
    if (!source) return;
    const incoming = source.querySelector('media-gallery');
    if (!incoming) return;

    const content = this.closest('#quick-add-modal-content.harven-quick-product-layout');
    if (content && !data.newProduct && content.contains(event.target)) {
      const currentIds = mediaIds(this);
      const incomingIds = mediaIds(incoming);
      if (currentIds && incomingIds &&
          currentIds.length === incomingIds.length &&
          currentIds.every((id, index) => id === incomingIds[index])) {
        if (incoming.dataset.harvenGalleryVariant) {
          this.dataset.harvenGalleryVariant = incoming.dataset.harvenGalleryVariant;
        }
        return;
      }
    }

    this.replaceWith(incoming);
  };

  #handleZoomMediaSelected = async (event) => {
    this.slideshow?.select(event.detail.index, undefined, { animate: false });
  };

  zoom(index, event) {
    this.refs.zoomDialogComponent?.open(index, event);
  }

  preloadImage(index) {
    const media = this.refs.zoomDialogComponent?.refs.media[index];
    if (media) this.refs.zoomDialogComponent?.loadHighResolutionImage(media);
  }

  get slideshow() { return this.refs.slideshow; }
  get media() { return this.refs.media; }
  get presentation() { return this.dataset.presentation; }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}
